import index from '../page/index.vue'
import contant from '../page/contant.vue'
import project from '../page/project.vue'
import product from '../page/product.vue'
import specialColumn from '../page/specialColumn.vue'
import show from '../page/show.vue'
import exhibition from '../page/exhibition.vue'
import appDownload from '../page/appDownload.vue'
import copyrightNotice from '../page/copyrightNotice.vue'
import aboutUs from '../page/aboutUs.vue'
import search from '../page/search.vue'
import projectDetail from '../page/second/projectDetail.vue'
import productDetail from '../page/second/productDetail.vue'
import exhibitionDetail from '../page/second/exhibitionDetail.vue'
import merchantDetail from '../page/second/merchantDetail.vue'
import showDetail from '../page/second/showDetail.vue'
import exhibtionOther from '../page/second/exhibtionOther.vue'
import usercenter from '../page/usercenter.vue'
import promotions from '../page/promotions.vue'
import promotionDetail from '../page/second/promotionDetail.vue'


import BasicLayout from '../components/main/main.vue'


const routes = [{
		path: '/web/',
		redirect: {
			name: 'index'
		},
		component: BasicLayout,
		children: [
			// 刷新页面 必须保留
			{
				path: 'refresh',
				name: 'refresh',
				hidden: true,
				component: {
					beforeRouteEnter(to, from, next) {
						next(instance => instance.$router.replace(from.fullPath))
					},
					render: h => h()
				}
			},
			// 页面重定向 必须保留
			{
				path: 'redirect/:route*',
				name: 'redirect',
				hidden: true,
				component: {
					beforeRouteEnter(to, from, next) {
						// console.log(rom.params.route)
						next(instance => instance.$router.replace(JSON.parse(from.params.route)))
					},
					render: h => h()
				}
			}
		]
	},
	{
		path: '',
		// redirect: '/index',
		component: index,
	},
	{
		path: '/',
		component: index,
	},
	{
		path: '/contant',
		component: contant,
	},
	{
		path: '/project',
		component: project,
	},
	{
		path: '/product',
		component: product,
	},
	{
		path: '/specialColumn',
		component: specialColumn,
	},
	{
		path: '/show',
		component: show,
	},
	{
		path: '/exhibition',
		component: exhibition,
	},
	{
		path: '/appDownload',
		component: appDownload,
	},
	{
		path: '/aboutUs',
		component: aboutUs,
	},
	{
		path: '/copyrightNotice',
		component: copyrightNotice,
	},
	{
		path: '/search',
		component: search,
	},
	{
		path: '/projectDetail/:id',
		component: projectDetail,
	},
	{
		path: '/productDetail/:id',
		component: productDetail,
	},
	{
		path: '/merchantDetail/:id',
		component: merchantDetail,
	},
	{
		path: '/showDetail/:id',
		component: showDetail,
	},
	{
		path: '/exhibitionDetail/:id',
		component: exhibitionDetail,
	},
	{
		path: '/exhibtionOther/:id',
		component: exhibtionOther,
	},
	{
		path: '/usercenter',
		component: usercenter,
	},
	{
		path: '/promotions',
		component: promotions,
	},
	{
		path: '/promotionDetail/:id',
		component: promotionDetail
	}
	
]

export default routes
